export const initialThemeState = {
  main: "default",
  apps: "light",
  sidebar: "white",
  skin: "light",
};

export const themeReducer = (state = initialThemeState, action) => {
  switch (action.type) {
    case "SET_THEME":
      return action.payload;
    case "CLEAR_THEME":
      return {};

    default:
      return state;
  }
};
